import React, { useState, useEffect } from "react";
import FieldsetSelect from "../../../../../components/FieldsetSelect/FieldsetSelect";
import { getService } from "../../../../../services/axios/services";
import CkEditor from "../../CkEditor/CkEditor";

const Conclusion = (props) => {
  const { handleFocus, title, data, type, setter, index, isEditable } = props;

  const [stateConclusionOptions, setStateConclusionOptions] = useState([]);
  const [state, setState] = useState(data);

  const getOptions = () => {
    getService({
      endpoint: "activities/evaluations/data/conclusions/types",
    }).then((response) => {
      const compiledData = [];
      response.data.forEach((item) => {
        compiledData.push({ id: item.id, name: item.value });
      });
      setStateConclusionOptions(compiledData);
    });
  };

  useEffect(() => {
    getOptions();
  }, []);

  // propagate synchronously so the parent always has the latest value before a blur-triggered save fires
  const handleChangeConclusion = (ev) => {
    const newState = { ...state, evaluation: parseInt(ev.target.value), title };
    setState(newState);
    setter(type, newState, index);
  };

  const handleChangeText = (ev, value) => {
    const newState = { ...state, text: value, title };
    setState(newState);
    setter(type, newState, index);
  };

  return (
    <div className="fieldContainer">
      <div className="fieldHeader">
        <div className="fieldTitle">
          <span>{title}</span>
        </div>
      </div>

      <div className="adequacySelects">
        <FieldsetSelect
          label="Avaliação"
          placeholder="Selecione"
          darkBackgroundColor={true}
          data={stateConclusionOptions}
          handleChange={handleChangeConclusion}
          handleFocus={() => handleFocus(true)}
          handleBlur={() => handleFocus(false)}
          selected={data.evaluation}
          disabled={!isEditable}
        />
      </div>

      <div className="editorArea">
        {isEditable ? (
          <CkEditor
            key={`conclusion-${index}-${data.id || index}-edit`}
            onChange={handleChangeText}
            onFocus={() => handleFocus(true)}
            onBlur={() => handleFocus(false)}
            data={data}
          />
        ) : (
          <div dangerouslySetInnerHTML={{ __html: data.text }} />
        )}
      </div>
    </div>
  );
};

export default Conclusion;
